import { GeckoMeasurementUnit } from 'types'
import { requiredNumberSchema } from 'utils/zodHelpers'
import { z } from 'zod'

import { ParserType } from './utils/enums'

export const FileSchema = z
  .object({
    component: z.string().min(1, 'Component is required'),
    unitID: z.string().min(1, 'Unit is required'),
    inspection: z.string().min(1, 'Inspection is required').optional(),
    date: z.string().min(1, 'Date is required').optional(),
    files: z.instanceof(FileList),
    x_offset: requiredNumberSchema,
    y_offset: requiredNumberSchema,
    x_unit: z.enum([
      GeckoMeasurementUnit.Degrees.id,
      GeckoMeasurementUnit.Meters.id,
      GeckoMeasurementUnit.Feet.id,
    ]),
    y_unit: z.enum([
      GeckoMeasurementUnit.Meters.id,
      GeckoMeasurementUnit.Feet.id,
    ]),
    parserType: z.enum([
      ParserType.Default,
      ParserType.GP_Brewton,
      ParserType.FALCON_H0,
    ]),
    binWidth: z.number().optional(),
    binHeight: z.number().optional(),
  })
  .superRefine((data, ctx) => {
    const fileArray = Array.from(data.files)
    if (data.files.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['files'],
        message: 'At least one file must be uploaded',
      })
    }

    const hasOnlyExcelFiles = fileArray.every(
      (file: File) =>
        file.type === 'application/vnd.ms-excel' ||
        file.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    )

    if (!hasOnlyExcelFiles) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['files'],
        message: 'Only .xls and .xlsx files are allowed',
      })
    }
  })

export type FileSchema = z.infer<typeof FileSchema>
